import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { formatSpecialtyJobTitle } from '../utils/formatting';

const PopupContainer = styled.div`
  min-width: 250px;
  max-width: 300px;
  padding: 0;
  
  @media (max-width: 768px) {
    min-width: 200px;
    max-width: 250px;
  }
`;

const JobTitle = styled.h3`
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
  color: #2c3e50;
  line-height: 1.3;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const JobLocation = styled.div`
  font-size: 0.9rem;
  color: #28346c;
  margin-bottom: 0.75rem;
  font-weight: 500;
`;

const JobMeta = styled.div`
  margin-bottom: 1rem;
`;

const JobMetaItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.25rem;
  font-size: 0.85rem;
`;

const JobMetaLabel = styled.span`
  color: #7f8c8d;
  font-weight: 600;
`;

const JobMetaValue = styled.span`
  color: #28346c;
  font-weight: 500;
`;

const ButtonContainer = styled.div`
  display: block;
  width: 100%;
`;

const ViewButton = styled(Link)`
  display: block;
  width: 100%;
  text-align: center;
  background-color: #28346c;
  color: white !important;
  padding: 0.6rem 1rem;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 0.9rem;
  box-sizing: border-box;
  
  &:hover {
    background-color: #1f2a50;
    color: white !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(40, 52, 108, 0.25);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:visited {
    color: white !important;
  }
  
  @media (max-width: 768px) {
    padding: 0.8rem 1rem;
    font-size: 0.95rem;
    min-height: 44px;
    border-radius: 8px;
  }
`;

const STATE_NAMES = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "FL": "Florida",
  "GA": "Georgia",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PA": "Pennsylvania",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming",
  "DC": "District of Columbia",
  "PR": "Puerto Rico",
  "VI": "Virgin Islands",
  "GU": "Guam",
  "AS": "American Samoa",
  "MP": "Northern Mariana Islands",
};

const getStateDisplayValue = (stateAbbr) => {
  return STATE_NAMES[stateAbbr] || stateAbbr;
};

const JobMapPopup = ({ job }) => {
  const jobTitle = job.Specialityn && job.JobTitlen
    ? formatSpecialtyJobTitle(job.Specialityn, job.JobTitlen).trim() 
    : job.JobTitlen || job.Specialityn || 'Job Title Not Available';

  const payRange = job.CalculatedPayRange || job.payRange;
  const shift = job.Shiftn || job.JR_Shift;
  const location = job.city && job.State ? `${job.city}, ${getStateDisplayValue(job.State)}` : 'Location Not Available';

  return (
    <PopupContainer>
      <JobTitle>{jobTitle}</JobTitle>
      
      <JobLocation>{location}</JobLocation>
      
      <JobMeta>
        {payRange && (
          <JobMetaItem>
            <JobMetaLabel>Weekly Pay:</JobMetaLabel>
            <JobMetaValue>{payRange.replace(/ weekly$/, '')}</JobMetaValue>
          </JobMetaItem>
        )}
        
        {shift && (
          <JobMetaItem>
            <JobMetaLabel>Shift:</JobMetaLabel>
            <JobMetaValue>{shift}</JobMetaValue>
          </JobMetaItem>
        )}
      </JobMeta>
      
      <ButtonContainer>
        <ViewButton to={`/jobs/${job.Record_Id}`}>View Details</ViewButton>
      </ButtonContainer>
    </PopupContainer>
  );
};

export default JobMapPopup;